module.exports = __webpack_public_path__ + "img/tasks.8a3451fb.png";